import React from "react";
import { IconButton, Grid } from "@material-ui/core";
import FilterIcon from "@material-ui/icons/FilterListOutlined";
import { DisplayDrawerContext } from "../../../../layout/DisplayDrawerContext";
import { useBusinessActivitiesReportFilter } from "../../../../data/reports/exchbusiness/businessActivities/hooks/useBusinessActivitiesReportFilter";
import { LocalizationContext } from "../../../../core/localization/Localization";
import { CustomTooltip } from "../../../components/common/CustomTooltip";
import { BusinessActivitiesFilterEditor } from "./BusinessActivitiesEditor";

export const BusinessActivitiesReportFilter: React.FunctionComponent = () => {
  const showWithDrawer = React.useContext(DisplayDrawerContext);
  const showFilter = React.useCallback(
    () => showWithDrawer(<BusinessActivitiesFiltersEditor />),
    [showWithDrawer]
  );

  const [filter, editfilter, save] = useBusinessActivitiesReportFilter();
  const { getString } = React.useContext(LocalizationContext);

  return (
    <Grid container alignItems="center" spacing={2}>
      <Grid item>
        <CustomTooltip titleKeyword="filterTooltip">
          <IconButton color="secondary" component="span" onClick={showFilter}>
            <FilterIcon />
          </IconButton>
        </CustomTooltip>
      </Grid>
    </Grid>
  );
};

const BusinessActivitiesFiltersEditor: React.FunctionComponent = () => {
  const [filter, editFilter, save] = useBusinessActivitiesReportFilter();
  return (
    <BusinessActivitiesFilterEditor
      filter={filter}
      editFilter={editFilter}
      save={save}
    />
  );
};
